import React from "react";

import CarteFrance from "./CarteFrance";
import KataEmptyState from "./KataEmptyState";
import KataSkeleton from "./KataSkeleton";
import PartenaireKataCard from "./PartenaireKataCard";

import Pagination from "../ui/Pagination";

export default function KataResults({
  viewMode,
  partenaires,
  departmentCounts,
  meta,
  loading,
  error,
  onDetails,
  onManage,
  onDepartmentSelect,
  onPageChange,
  onReset,
}) {
  if (loading) {
    return <KataSkeleton />;
  }

  if (error) {
    return (
      <div className="rounded-3xl border border-red-200 bg-red-50 p-6 text-center dark:border-red-400/20 dark:bg-red-400/10">
        <h3 className="font-semibold text-red-800 dark:text-red-200">
          Impossible de charger les annonces
        </h3>

        <p className="mt-2 text-sm text-red-700 dark:text-red-300">
          {error}
        </p>
      </div>
    );
  }

  if (viewMode === "map") {
    return (
      <CarteFrance
        departmentCounts={departmentCounts}
        onDepartmentSelect={onDepartmentSelect}
      />
    );
  }

  if (!partenaires.length) {
    return (
      <KataEmptyState onReset={onReset} />
    );
  }

  return (
    <div className="space-y-8">
      <div className="grid items-stretch gap-5 md:grid-cols-2 xl:grid-cols-3">
        {partenaires.map((partenaire) => (
          <PartenaireKataCard
            key={partenaire.id}
            partenaire={partenaire}
            onDetails={onDetails}
            onManage={onManage}
          />
        ))}
      </div>

      <Pagination
        page={meta.page}
        totalPages={meta.total_pages}
        onChange={onPageChange}
      />
    </div>
  );
}